export default {
  type: "",
  data: {},
  deleted: {},
  error: ""
};
